import React from 'react';

import { ErrorTrackingProps } from 'features/authentication/SignIn/types';

import { EVENT_CATEGORIES } from 'util/tracking_constants';
import { withUxPartition } from 'util/uxEvents';

import ForgotPasswordFlow from './ForgotPasswordFlow';

type Props = {
  onSuccess: () => void;
} & ErrorTrackingProps;

const ForgotPasswordContainer = ({ onError, onSuccess }: Props) => (
  <ForgotPasswordFlow onError={onError} onSuccess={onSuccess} />
);

export default withUxPartition({
  eventCategory: EVENT_CATEGORIES.FORGOT_PASSWORD,
})(ForgotPasswordContainer);
